//@ts-nocheck

'use client'

import React from "react";

import * as S from './HeroQuaternary.styles'

import { Container, Row, Col, SpacerBase } from "../../../atoms/GridSystem";
import { Heading, Paragraph } from "../../../atoms/Typography/Typography.component";
import Image from "next/image";
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'
import { useContext } from 'react'

const HeroQuaternary = ({ image, title, paragraph, imageShape, colorScheme }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.HeroQuaternary colorScheme={colorScheme || selectedColorScheme}  >
      <Container>
        <Row $reverse={['xs', 'sm', 'md']}>
          <Col xs={12} xl={5} $justify={"center"}>
            <S.HeroQuaternaryContent>
              <Heading 
                {...title}
                weight={'medium'}
              />
              <SpacerBase xs={3} />
              <Paragraph typo={'paragraphMD'} content={paragraph} />
            </S.HeroQuaternaryContent>
          </Col>
          <Col xs={12} xl={7} $justify={"center"}>
            <S.HeroQuaternaryMaskWrapper maskType={imageShape}>
              <Image {...image} fill />
            </S.HeroQuaternaryMaskWrapper>
          </Col>
        </Row>
      </Container>
    </S.HeroQuaternary>
  )
}

export default HeroQuaternary